module.exports = __webpack_public_path__ + "static/img/express-blast2.24a6aac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/express-blast2.jpg
// module id = ck/k
// module chunks = 1